import React, { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import imagePng from "images/hero-right.png";
import HeroSearchForm from "components/HeroSearchForm/HeroSearchForm";
import { useNavigate } from "react-router-dom";

export interface SectionHeroProps {
  className?: string;
}

const SectionHero: FC<SectionHeroProps> = ({ className = "" }) => {
  const navigate = useNavigate(); // Sposta l'uso di useNavigate qui

  const handleVaiAlleStanze = () => {
    // console.log("Vai agli appartamenti");
    navigate(`/appartamenti`);
  };

  return (
    <div
    className={`nc-SectionHero flex flex-col-reverse lg:flex-col relative ${className}`}
    data-nc-id="SectionHero"
  >
    <div className="flex flex-col lg:flex-row lg:items-center">
      <div className="flex-shrink-0 lg:w-1/2 flex flex-col items-start space-y-8 sm:space-y-6 pb-14 lg:pb-64 xl:pr-14 lg:mr-10 xl:mr-0">
        <h2 className="font-medium text-4xl md:text-5xl xl:text-7xl !leading-[114%] ">
          Benvenuti in Villa Greco
        </h2>
        <span className="text-base md:text-lg text-neutral-500 dark:text-neutral-400">
          Scopri il comfort dei nostri appartamenti e vivi un'esperienza unica.
          Prenota ora il tuo soggiorno e rilassati nel nostro ampio giardino.
        </span>
       

        <ButtonPrimary onClick={handleVaiAlleStanze}>Scopri i nostri Appartamenti</ButtonPrimary>
      </div>
      <div className="flex-grow">
        <img
          className="w-full"
          src={imagePng}
          alt="Immagini villa Benvenuti al Villa Greco"
        />
      </div>
    </div>

{/* per cercare */}
    <div className="hidden lg:block z-10 mb-12 lg:mb-0 lg:-mt-40 w-full">
        {/* <HeroSearchForm /> */}
      </div>
    </div>
  );
};

export default SectionHero;
